/*
  PromotionProduct_v1.js propTypes
  extracted from http://localhost:3000/documentation/resources/oaspec.json
  on 2018-04-23T13:43:27.206Z
*/

import { arrayOf, string } from 'prop-types'

export default {
  code: string,
  codes: arrayOf(string),
  description: string,
  headline: string,
  packshot: string,
  type: string,
}
